import {
  Box, Button, Grid, Typography, Container,
} from '@mui/material';
import React from 'react';
import {
  Carousel,
  Typography700,
  DealCardWrapper,
} from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/location-module/LocationViewV2/components/DealsSection/DealsSection.styles';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';

const DealsSection = (props) => {
  const { content, data } = props;
  return (
    <StyledBox>
      <Container className="LVCustomContainer">
        <Box className="DSHeader">
          <Box>
            <Typography700 component="h3" variant="h4" mb={3}>
              {content.LocationPage.DealTitle}
            </Typography700>
            <Typography variant="body1" component="p" className="DSSubtitle">
              {interpolateString(content.LocationPage.DealSubtitle, {
                location: data.location.display_name,
                count: data.location.total_deals_count,
              })}
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className="DSButton"
            component={NavigatorLink}
            href={PATHS.motorcycleDeals.slug(data.location.slug)}>
            {interpolateString(content.LocationPage.DealsBtn, {
              location: data.location.display_name,
            })}
          </Button>
        </Box>
        <Box position="relative" className="showDESKTOP">
          <Carousel
            arrowOutside
            swipeable
            infinite
            showDots={false}
            keyBoardControl
            minimumTouchDrag={20}
            renderDotsOutside
            deskTopItems={3}
            carouselArrow
            customTransition="transform 200ms ease-in">
            {data.hot_deals.map((item) => (
              <DealCardWrapper
                key={item.id}
                dealItem={item}
                content={content.DealCardComponent}
              />
            ))}
          </Carousel>
        </Box>
        <Box className="showTABLET">
          <Grid container columnSpacing={2} rowSpacing={4}>
            {data.hot_deals.slice(0, 4).map((item) => (
              <Grid item md={6} sm={12} key={item.id}>
                <DealCardWrapper
                  dealItem={item}
                  content={content.DealCardComponent}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { DealsSection };
